import React from "react";

export default function Footer() {
    function scrollToTop() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    return (
        <footer id="siteFooter">
            <div id="footerInner">
                <p id="footerName">Shashank Bidhuri</p>
                <ul id="footerLinks">
                    <li><a href="#main" className="link">Home</a></li>
                    <li><a href="#projectRoot" className="link">Projects</a></li>
                    <li><a href="#experienceRoot" className="link">Experience</a></li>
                    <li><a href="#techStackRoot" className="link">Skills</a></li>
                    <li><a href="#aboutRoot" className="link">About</a></li>
                    <li><a href="#contactMe" className="link">Contact</a></li>
                </ul>
                <div id="footerSocials">
                    <a href="https://github.com/justShashank57" target="_blank" rel="noreferrer" aria-label="GitHub">
                        <img src="square-github.svg" alt="GitHub" className="footerIcon" />
                    </a>
                    <a href="https://www.linkedin.com/in/shashank-bidhuri-47a892249/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                        <img src="linkedin.svg" alt="LinkedIn" className="footerIcon" />
                    </a>
                    <a href="https://www.instagram.com/just_shashank__/" target="_blank" rel="noreferrer" aria-label="Instagram">
                        <img src="square-instagram.svg" alt="Instagram" className="footerIcon" />
                    </a>
                </div>
                <button id="backToTop" onClick={scrollToTop} aria-label="Back to top">
                    ↑ Back to top
                </button>
                <p id="footerCopyright">© {new Date().getFullYear()} Shashank Bidhuri. All rights reserved.</p>
            </div>
        </footer>
    );
}
